import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'

const DevelopmentPath = ({ developmentPath }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { langForTransState, isTranslated },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(
    () => cardBodyRef.current?.innerHTML,
  )

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await fetcherAPI.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcher()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!developmentPath?.length) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, developmentPath, dispatch, originalTitle])

  useEffect(() => {
    startTransition(() => {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.DEVELOPMENTPATHDOM,
          payload: cardBodyRef.current?.outerHTML,
        })
      }, 1000)
    })
  }, [isTranslated, dispatch, originalTitle, translations])

  return (
    <>
      {!!developmentPath?.length && !isTranslated && (
        <div
          ref={cardBodyRef}
          style={{
            marginTop: '30px',
            marginBottom: '30px',
          }}>
          <h3
            style={{
              marginTop: '30px',
              marginBottom: '16px',
              fontFamily: 'L10',
              fontStyle: 'normal',
              fontWeight: 700,
              fontSize: '18px',
              lineHeight: '18px',
              letterSpacing: '0.0714286px',
            }}>
            Development path
          </h3>
          {developmentPath.map((dp, i) => (
            <div
              key={i}
              style={{
                marginTop: '16px',
                overflowX: 'hidden',
                display: 'flex',
              }}>
              <div
                style={{
                  fontFamily: 'L10',
                  fontStyle: 'normal',
                  fontSize: '13px',
                  lineHeight: '20px',
                  paddingRight: '6px',
                  display: 'flex',
                }}>
                <p
                  style={{
                    fontWeight: 500,
                    margin: 0,
                  }}>
                  {dp?.year}
                </p>
                <span
                  style={{
                    paddingLeft: '1px',
                    paddingRight: '1px',
                  }}>
                  {':'}{' '}
                </span>
              </div>
              <p
                style={{
                  fontFamily: 'L10',
                  fontStyle: 'normal',
                  margin: 0,
                  fontSize: '13px',
                  lineHeight: '20px',
                }}>
                {dp?.description}
              </p>
            </div>
          ))}
        </div>
      )}

      {!!isTranslated && !!developmentPath?.length && (
        <div
          ref={cardBodyRef}
          dangerouslySetInnerHTML={{
            __html: translations?.res1?.data,
          }}
          style={{
            marginTop: '30px',
            marginBottom: '30px',
          }}></div>
      )}
    </>
  )
}

export default DevelopmentPath
